/**
 * Renders a tab count for TabsCount: `-` until the count has loaded (or when
 * it failed to). Shared by every manager that shows a count pill so the
 * loading/error placeholder can't drift between tab bars.
 */
export const formatTabCount = (count: number | null | undefined): string =>
  typeof count === 'number' ? count.toString() : '-';
